import React, { useEffect, useState, useRef } from "react";
import { Module } from "../../types/module";
import { getModuleByName } from "../../services/Administracion/modulesService";
import IconPicker from "../IconPicker";


interface ModuleModalProps {
    module: Module;
    onClose: () => void;
    onSave: (module: Module) => void;
}


const ModuleModal: React.FC<ModuleModalProps> = ({ module, onClose, onSave }) => {
    const [moduleName, setModuleName] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [iconClass, setIconClass] = useState<string>('');
    const [isActive, setIsActive] = useState<boolean>(true);
    const [isFormValid, setIsformValid] = useState<boolean>(false);
    const [errors, setErrors] = useState<{ moduleName?: string; moduleDescription?: string }>({});
    const moduleNameInputRef = useRef<HTMLInputElement>(null);
    const descriptionInputRef = useRef<HTMLTextAreaElement>(null);

    const handleSave = () => {
        onSave({ ...module, module_name: moduleName, description, icon_class: iconClass, is_active: isActive });
    };

    useEffect(() => {
        if (module.module_id) {
            setModuleName(module.module_name);
            setDescription(module.description || '');

            setIsActive(module.is_active);
            setIconClass(module.icon_class || '');
            setErrors({});
        }
        if (!module.module_id && moduleNameInputRef.current) {
            moduleNameInputRef.current.focus();
        } else if (module.module_id && descriptionInputRef.current) {
            descriptionInputRef.current.focus();
        }
    }, [module]);

    useEffect(() => {
        const validarErrores =
            moduleName.trim() !== '' &&
            (!errors.moduleName || errors.moduleName === '') &&
            (!errors.moduleDescription || errors.moduleDescription === '');
        setIsformValid(validarErrores);
    }, [moduleName, isActive, errors]);

    const validateModuleName = async (moduleName: string) => {
        console.log('Validando nombre del modulo: ', moduleName);
        try {
            const existingModule = await getModuleByName(moduleName);
            if (existingModule.module_id) {
                return {
                    isValid: false,
                    errorMessage: `El modulo ${existingModule.module_name} YA existe`
                }
            }
            return {
                isValid: true,
                errorMessage: ''
            }
        } catch (error: any) {
            if (error.response.status !== 404) {
                return {
                    isValid: false,
                    errorMessage: error.message || 'Error validando el nombre del módulo'
                }
            }
        }
    };

    const validateField = async (fieldName: string, value: string) => {
        let errorMessage = '';
        if (value.trim() === '') {
            errorMessage = 'Este campo es requerido';
        }
        setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));

        if (fieldName === 'moduleName' && value.trim() !== '') {
            const validation = await validateModuleName(value);
            if (!validation?.isValid) {
                setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: validation?.errorMessage }));
            } else {
                setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: '' }));
            }
        }
    };

    return (
        <div className='modal show d-block' tabIndex={-1} role='dialog'>
            <div className='modal-dialog modal-dialog-centered' role='document'>
                <div className='modal-content shadow-lg bg-light'>
                    <div className='modal-header'>
                        <h5 className='modal-title'>
                            {module.module_id ? 'Editar' : 'Crear'} módulo ({module.module_id})</h5>
                        <button type='button' className='btn-close' data-dismiss='modal' aria-label='Close' onClick={onClose}>
                        </button>
                    </div>
                    <div className='modal-body'>
                        <div className='form-group'>
                            <label htmlFor='moduleName'>Nombre del módulo</label>
                            <input
                                type='text'
                                className={`form-control ${errors.moduleName ? 'is-invalid' : ''}`}
                                id='moduleName'
                                value={moduleName}
                                onBlur={e => validateField('moduleName', e.target.value)}
                                onChange={(e) => {
                                    setModuleName(e.target.value);
                                }}
                                ref={moduleNameInputRef}
                            />
                            <div className='invalid-feedback'>{errors.moduleName}</div>
                        </div>
                        <div className='form-group'>
                            <label htmlFor='description'>Descripción</label>
                            <textarea
                                className={`form-control ${errors.moduleDescription ? 'is-invalid' : ''}`}
                                id='description'
                                value={description}
                                onChange={(e) => {
                                    setDescription(e.target.value);
                                    validateField('moduleDescription', e.target.value);
                                }}
                                ref={descriptionInputRef}
                            />
                            <div className='invalid-feedback'>{errors.moduleDescription}</div>
                        </div>
                        {/* <div className="form-group">
                            <label htmlFor="iconClass">Icon</label>
                            <input
                                type="text"
                                className="form-control"
                                id="iconClass"
                                value={iconClass}
                                onChange={(e) => setIconClass(e.target.value)}
                            />
                        </div> */}
                        <div className="mb-3 form-group">
                            <label htmlFor="iconClassPicker" className="form-label">Ícono</label>
                            <IconPicker
                                value={iconClass}
                                onChange={(newIcon) => setIconClass(newIcon)}
                            />
                        </div>

                        <div className='form-check'>
                            <input
                                type='checkbox'
                                className='form-check-input'
                                id='isActive'
                                checked={isActive}
                                onChange={(e) => setIsActive(e.target.checked)}
                            />
                            <label className='form-check-label' htmlFor='isActive'>
                                Activo
                            </label>
                        </div>
                    </div>
                    <div className='modal-footer'>
                        <button type='button' className='btn btn-secondary' onClick={onClose}>
                            Cancelar
                        </button>
                        <button type='button' className='btn btn-primary' onClick={handleSave} disabled={!isFormValid}>
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModuleModal;
